<template>
  <div class="history-bg" style="padding: 0; height: 100%; position: relative">
    <div
      class=""
      id="qxFour"
      @mouseenter="clearDispatchTimer"
      @mouseleave="setDispatchTimer"
      style="height: 100%; width: 100%"
    ></div>
    <!-- <img src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%8E%86%E5%8F%B2%E6%95%B0%E6%8D%AE%E8%83%8C%E6%99%AF%402x%20%281%29.png"
            style="width: 90px;height: 90px;position: absolute;top: 13px;right: 38px;" alt="">
        <div class="flexCol alit justc" style="width: 90px;height: 90px;position: absolute;top: 13px;right: 38px;">
            <div class="" style="width: 22px;font-size: 10px;color: #FFFFFF;">历史湿度</div>
        </div> -->
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
export default {
  data() {
    return {
      interVal: "",
      myChart: null,
      app: {
        currentIndex: -1,
      },
      dispatchTimer: null,
      dataLen: null,
    };
  },
  mounted() {
    // this.requestData(500)
    this.init();
  },
  methods: {
    requestData(number, area, tulongNum, beforeMoney, afterMoney) {
      this.$request(
        "center/newService1/farmLines?num=" +
          number +
          "&area=" +
          area +
          "&tulongNum=" +
          tulongNum +
          "&beforeMoney=" +
          beforeMoney +
          "&afterMoney=" +
          afterMoney
      ).then((res) => {
        if (this.myChart) {
          clearInterval(this.dispatchTimer);
          this.myChart.clear();
        }
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type == 1) {
            this.init(res.data[i].list);
          }
        }
      });
    },
    init(pageData, type) {
      let that = this;
      that.myChart = echarts.init(document.getElementById("qxFour"));

      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });

      let topData = [
        3.2, 2.8, 3.5, 2.5, 3.7, 2.3, 3.9, 2.1, 3.4, 2.6, 3.8, 2.2, 3.6, 2.4
      ];
      let bottomData = [21.5, 20.2, 22.8, 19.3, 23.7, 18.6, 21.9, 20.7, 22.4, 19.8, 23.1, 18.9, 22.3, 20.5];
      let timeData = [
        "1:00",
        "2:00",
        "3:00",
        "4:00",
        "5:00",
        "6:00",
        "7:00",
        "8:00",
        "9:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
      ];

      var option = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "#021d3a",
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0, 255, 233,0)",
                  },
                  {
                    offset: 0.5,
                    color: "rgba(255, 255, 255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 233,0)",
                  },
                ],
                global: false,
              },
            },
          },
          textStyle: {
            color: "#fff",
          },
          //formatter: '{b0}: {c0}<br />{b1}: {c1} KB/s',
          formatter: function (params) {
            //自定义函数修改折线图给数据加单位
            var str = ""; //声明一个变量用来存储数据
            str += "<div>" + params[0].name + "</div>"; //显示日期的函数
            for (var i = 0; i < params.length; i++) {
              // console.log(params[1].seriesName,1111111)
              //图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位
              str +=
                '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
                params[i].color +
                ';"></span>' +
                params[i].seriesName +
                "</span> : <span>" +
                params[i].data;
              if (params[i].seriesName == "温度") {
                str += "℃" + "</br>";
              } else {
                str += "%" + "</br>";
              }
            }
            return str;
          },
          extraCssText: "z-index:2",
        },
        legend: {
          top: "-0%",
          left: "65%",
          data: ["温度", "湿度"],
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          top: "13%",
          left: "5%",
          right: "0%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: true,
            },
            splitArea: {
              // show: true,
              color: "#fff",
              lineStyle: {
                color: "#fff",
              },
            },
            axisLabel: {
              interval: 2,
              color: "#fff",
            },
            splitLine: {
              show: false,
            },
            boundaryGap: false,
            data: timeData,
          },
        ],

        yAxis: [
          {
            type: "value",
            min: 0,
            max: 100,
            splitNumber: 6,
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#fff"],
                opacity: 0.6,
              },
            },
            axisLine: {
              show: true,
            },

            axisLabel: {
              show: true,
              margin: 20,
              formatter: "{value}",
              textStyle: {
                fontSize: 14,
                color: "#fff",
              },
            },
            axisTick: {
              show: true,
            },
          },
        ],
        series: [
          {
            name: "温度",
            type: "line",
            smooth: false, //是否平滑
            showAllSymbol: true,
            //   symbol: 'circle',
            symbolSize: 0,
            lineStyle: {
              normal: {
                color: "#FFBC0D",
                shadowColor: "rgba(0, 0, 0, 0)",
                shadowBlur: 0,
                shadowOffsetY: 5,
                shadowOffsetX: 5,
              },
            },
            label: {
              show: false,
              position: "top",
              textStyle: {
                color: "#FFF",
                fontSize: 14,
              },
            },
            itemStyle: {
              color: "#FFBC0D",
              borderColor: "rgb(108,78,0)",
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0)",
              shadowBlur: 0,
              shadowOffsetY: 0,
              shadowOffsetX: 0,
            },
            tooltip: {
              show: true,
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [],
                global: false, // 缺省为 false
              },
            },
            data: topData,
          },
          {
            name: "湿度",
            type: "line",
            smooth: false, //是否平滑
            showAllSymbol: true,
            // symbol: 'image://./static/images/guang-circle.png',
            //   symbol: 'circle',  //取消注释legend就是实心的
            symbolSize: 0,
            lineStyle: {
              normal: {
                color: "#41B5FF",
                shadowColor: "rgba(0, 0, 0, 0)",
                shadowBlur: 0,
                shadowOffsetY: 5,
                shadowOffsetX: 5,
              },
            },
            label: {
              show: false,
              position: "top",
              textStyle: {
                color: "#fff",
                fontSize: 14,
              },
            },
            itemStyle: {
              color: "#00DAFF",
              borderColor: "rgb(0,115,100)",
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0)",
              shadowBlur: 0,
              shadowOffsetY: 0,
              shadowOffsetX: 0,
            },
            tooltip: {
              show: true,
            },
            data: bottomData,
          },
        ],
      };
      setInterval(() => {
        //这里采用的是随机数，实际情况需要向后台获取
        let date = new Date();
        let hh = date.getHours();
        let mm =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        let ss =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        let time = hh + ":" + mm + ":" + ss;
        timeData.splice(0, 1);
        timeData.push(time);
        let topNum = Math.random();
        let bottomNum = Math.random();
        // topData.splice(0, 1);
        topData.push(topNum.toFixed(2));
        // bottomData.splice(0, 1);
        bottomData.push(bottomNum.toFixed(2));
        that.myChart.setOption(option);
      }, 2000);

      that.dataLen = option.series[0].data.length;
      // that.dispatchActions()

      that.myChart.setOption(option);
      // this.interVal = setInterval(function () {
      //     that.myChart.clear()
      //     that.myChart.setOption(option);
      // }, 240000)
      // 20000
    },
    dispatchActions() {
      let that = this;
      that.dispatchTimer = setInterval(function () {
        // 取消之前高亮的图形
        that.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
        //console.log(app.currentIndex);
        // 高亮当前图形
        that.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        // 显示 tooltip
        that.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
      }, 3000);
    },
    clearDispatchTimer() {
      clearInterval(this.dispatchTimer);
    },
    setDispatchTimer() {
      this.dispatchActions();
    },
  },
  destroyed() {
    clearInterval(this.interVal);
  },
};
</script>

<style>
</style>